
import "./Emoji.scss";
import classNames from 'classnames';
import React, { useCallback, useEffect } from "react";
import { EmojiEnum } from "../../models/EmojiEnum";
import { PlayerPublic } from "../../models/Player";
import store from "../../store/store";
import { emojiActions } from "./emojiSlice";
import useGlobalBodyClick from "../../hooks/useGlobalBodyClick";

export default function Emoji(props: {
  size: number,
  player: Partial<PlayerPublic> | null,
  isClient: boolean,
  emoji: string | undefined,
}) {

  const gameState = store.getState().game;

  const {
    size,
    player,
    isClient = false,
    emoji,
  } = props;

  const [showTooltip, setShowTooltip] = React.useState(false);

  const keyPressed = useCallback((event) => {
    switch (event.key) {
      case 'Escape':
        setShowTooltip(false);
        break;
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useGlobalBodyClick((target: Element) => {
    if (showTooltip) {
      setShowTooltip(false);
    }
  });

  useEffect(() => {
    document.addEventListener("keydown", keyPressed, false);

    return () => {
      document.removeEventListener("keydown", keyPressed, false);
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (!!emoji) {
      setTimeout(() => {
        store.dispatch(emojiActions.stopEmoji({ gameId: gameState.gameId, playerId: player?.playerId }))
      }, 4000);
    }
  }, [emoji]); // eslint-disable-line react-hooks/exhaustive-deps

  const classes = classNames({
    'emoji': true,
    'emoji_client': isClient,
    'emoji_active': !!emoji,
  });

  function toggleTooltip() {
    if (!emoji) {
      setShowTooltip(!showTooltip);
    }
  }

  function sendEmoji(selectedEmoji: string | null) {
    if (!gameState.isConnected || emoji) {
      return;
    }
    setShowTooltip(false);
    if (player) {
      store.dispatch(emojiActions.sendEmoji({
        gameId: gameState.gameId,
        emoji: selectedEmoji,
        playerId: player?.playerId || '',
      }));
    }
  }

  return (
    <div className={classes} style={{ width: size, height: size }} onClick={() => isClient ? toggleTooltip() : null}>
      {showTooltip &&
        <div className="emoji_tooltip game_tooltip" onClick={(e) => { e.stopPropagation() }}>
          <div onClick={() => setShowTooltip(false)} className="close_button">×</div>
          <div className="emoji_tooltip_list">
            <div className="flex-row">
              <div
                onClick={() => sendEmoji(null)}
                className="emoji_tooltip_list_emoji emoji_tooltip_list_clear danger-text"
              >
                ⌫
              </div>
            </div>

            {(Object.keys(EmojiEnum) as Array<keyof typeof EmojiEnum>).map((it, i) =>
              <div
                key={i}
                onClick={() => sendEmoji(EmojiEnum[it])}
                className="emoji_tooltip_list_emoji"
              >
                {EmojiEnum[it]}
              </div>
            )}

          </div>
        </div>
      }
      <span className="emoji_reaction">
        {emoji}
      </span>
    </div>
  )
}
